module.exports = __webpack_public_path__ + "media/images/emblems/Rances-coat_of_arms-b48c81f8d991661762e0c0aba42bff79.svg";